import { AnalyticsAction } from '@/config/analytics';
import env from '@/env';
import { getSubdomain } from '@/utils';

const subdomain = getSubdomain();
const isTymeSubDomain = subdomain === env.app.tymeSubDomain;

const navMenus = [
  {
    label: 'APIs',
    url: '/apis',
    analytics: AnalyticsAction.LC_header_apis,
  },
];

if (!isTymeSubDomain) {
  navMenus.push({
    label: 'Showcase',
    url: '/showcase',
    analytics: AnalyticsAction.LC_header_showcase,
  });
}

export { navMenus };
